import { render, staticRenderFns } from "./BlogPageControls.vue?vue&type=template&id=5b68e33b&"
import script from "./BlogPageControls.vue?vue&type=script&lang=js&"
export * from "./BlogPageControls.vue?vue&type=script&lang=js&"
import style0 from "./BlogPageControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports